<template>
    <div class="wrap-service-clients">
        <header-app></header-app>
        <div class="clients-banner"> </div>
        <div class="clients-details">
            <div class="clients-center-new animation">
                <div class="clients-center-nav">
                    <div class="clients-nav-item" @click="changeItem(item)" :class="{'clients-nav-item-active':showItem == item.id}"  v-for="(item,index) in clientsList" :key="index">{{item.region}}</div>
                </div>
            </div>
            <div class="client-body-wrapper animation">
                <div class="client-body-item" v-for="(item,index) in clientsItem" :key="index">
                    <div class="before-hover">
                        <img :src="item.grayimg" alt="" />
                        <img :src="item.colorimg" alt="" />
                    </div>
                    <div class="hover-text">{{item.name}}</div>
                </div>
            </div>
            <bottom-app></bottom-app>
            <top-scroll></top-scroll>
        </div>
    </div>
</template>

<script>
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import headerApp from '@/components/headerApp.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        data(){
          return {
              clientsList:[],
              showItem:1,
              clientsItem:[]
          }
        },
        methods:{
            changeItem(item){
                this.showItem = item.id || 1
                this.clientsItem = item.clients || []
            }
        },
        created(){
            this.$api.clientsList().then((res)=>{
                if(res){
                    this.clientsList = res || []
                    this.changeItem(this.clientsList[0])
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-service-clients{
        text-align: left;
        .clients-banner{
            width: 100%;
            height:7rem;
            background: url(../../assets/imgs/tp-clients-bg.png) no-repeat top center;
            background-size: cover;
        }
        .clients-details{
            position: absolute;
            top: .2rem;
        }
        .clients-center-new{
            padding: 2rem .5rem 0 .5rem;
            .clients-center-nav{
                font-size: .22rem;
                color: #858585;
                font-weight: 600;
                overflow: hidden;
                background: #f4f3f3;
                border-radius: .3rem;
                line-height: 0.62rem;
                .clients-nav-item{
                    text-align: center;
                    padding: 0 0.4rem;
                    cursor: pointer;
                    display: inline-block;
                    &:first-child{
                        padding: 0 0.4rem;
                    }
                    &.clients-nav-item-active{
                        background-color: #fff;
                        color: #ec1e25;
                        border-radius: 0.3rem;
                    }
                }
            }
        }
        .client-body-wrapper{
            display: block;
            margin: .44rem .5rem 0 .5rem;
            .client-body-item {
                cursor: pointer;
                width: 2rem;
                height: 2rem;
                background: #fff;
                display: inline-table;
                margin-right: 0.2rem;
                margin-bottom: 0.19rem;
                position: relative;
                box-shadow: 0 0 20px rgba(0,0,0,.2);
                &:nth-child(3n){
                    margin-right: 0;
                }
                &:hover{
                    background: #f8f8f8;
                    img:nth-child(1){
                        display: none;
                    }
                    img:nth-child(2){
                        display: inline-block !important;
                    }
                    .hover-text{
                        display: inline-block;
                    }
                }
                .before-hover{
                    display: table-cell;
                    vertical-align: middle;
                    text-align: center;
                    img{
                        width: 50%;
                    }
                    img:nth-child(2){
                        display: none;
                    }
                }
                .hover-text {
                    display: none;
                    z-index: 10;
                    left: 0;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    background: #ec1e25;
                    height: 0.5rem;
                    font-size: 0.22rem;
                    line-height: .5rem;
                    color: #fff;
                    font-weight: 600;
                    text-align: center;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
</style>